var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('MediaTypeForm',{class:_vm.senderTypeClass,attrs:{"message":_vm.message},on:{"submit":function($event){_vm.$emit('submit', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }